export default __webpack_public_path__ + "static/media/9.83e02095.svg";